import "./instrument";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./i18n";
import { captureClientException } from "@/lib/sentryCapture";
import { pruneLegacyMinistryMemosKeys } from "./lib/localStorageKeys";

pruneLegacyMinistryMemosKeys();

/** Escape text before injecting into static HTML (bootstrap errors only). */
function escapeHtmlForBootstrap(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

const rootEl = document.getElementById("root");
if (!rootEl) {
  document.body.innerHTML = "<div style='padding:2rem;font-family:system-ui;'>Root element not found.</div>";
} else {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
  if (!supabaseUrl || !supabaseKey) {
    rootEl.innerHTML = `<div style="padding:2rem;max-width:40rem;margin:2rem auto;font-family:system-ui;line-height:1.5;color:#111">
      <h1 style="font-size:1.25rem;margin:0 0 0.75rem">Missing Supabase configuration</h1>
      <p style="margin:0 0 1rem">This app needs <code style="background:#f4f4f5;padding:0.1rem 0.35rem;border-radius:4px">VITE_SUPABASE_URL</code> and <code style="background:#f4f4f5;padding:0.1rem 0.35rem;border-radius:4px">VITE_SUPABASE_PUBLISHABLE_KEY</code> in a <code style="background:#f4f4f5;padding:0.1rem 0.35rem;border-radius:4px">.env</code> file at the project root.</p>
      <p style="margin:0 0 1rem">Copy <code style="background:#f4f4f5;padding:0.1rem 0.35rem;border-radius:4px">.env.example</code> to <code style="background:#f4f4f5;padding:0.1rem 0.35rem;border-radius:4px">.env</code>, add your Supabase project URL and anon key from the dashboard, then restart <code style="background:#f4f4f5;padding:0.1rem 0.35rem;border-radius:4px">npm run dev</code>.</p>
    </div>`;
  } else {
    void import("./App.tsx")
      .then(({ default: App }) => {
        try {
          createRoot(rootEl).render(<App />);
        } catch (err) {
          captureClientException(err, { tags: { bootstrap: "render" } });
          rootEl.innerHTML = `<div style='padding:2rem;font-family:system-ui;color:#333'><h2>Failed to load app</h2><pre style='font-size:12px;overflow:auto'>${escapeHtmlForBootstrap(String(err))}</pre></div>`;
        }
      })
      .catch((err: unknown) => {
        captureClientException(err, { tags: { bootstrap: "import-app" } });
        const message = err instanceof Error ? err.message : String(err);
        rootEl.innerHTML = `<div style="padding:2rem;max-width:40rem;margin:2rem auto;font-family:system-ui">
          <h2 style="font-size:1.25rem">Failed to load app</h2>
          <pre style="font-size:12px;overflow:auto;background:#f4f4f5;padding:1rem;border-radius:8px">${escapeHtmlForBootstrap(message)}</pre>
        </div>`;
      });
  }
}
